export enum UserRole {
  Anonymus = 'ANONYMUS',
  Internal = 'INTERNAL',
  Producer = 'PRODUCER',
  Buyer = 'BUYER',
  BuyerPlItalia = 'BUYER_PL_ITALIA',
  Consumer = 'CONSUMER',
}
